import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FilterCheckboxItem } from './FilterCheckboxItem';

interface AIAgentGoalFilterProps {
  filterIndex: number;
}

/**
 * Renders checkboxes for filtering sessions by AI agent goal achievement status
 */
export const AIAgentGoalFilter = ({ filterIndex }: AIAgentGoalFilterProps) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const goalAchieved = useWatch({ control, name: `filters.${filterIndex}.goalAchieved` }) || [];

  const handleGoalToggle = (value: number, checked: boolean) => {
    const currentValues = Array.isArray(goalAchieved) ? [...goalAchieved] : [];
    const newValues = checked
      ? [...currentValues, value]
      : currentValues.filter((v: number) => v !== value);

    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, goalAchieved: newValues });
  };

  const goalOptions = [
    { value: 1, label: t('analytics.filters.goalAchieved.achieved') },
    { value: 2, label: t('analytics.filters.goalAchieved.partiallyAchieved') },
    { value: 3, label: t('analytics.filters.goalAchieved.failed') },
  ];

  return (
    <div className="space-y-2">
      {goalOptions.map(({ value, label }) => {
        const isChecked = goalAchieved.includes(value);

        return (
          <FilterCheckboxItem
            key={value}
            id={`goal-${value}`}
            checked={isChecked}
            onCheckedChange={(checked) => handleGoalToggle(value, checked as boolean)}
          >
            <span className="text-sm">{label}</span>
          </FilterCheckboxItem>
        );
      })}
    </div>
  );
};
